import { Navigate, useLocation } from "react-router-dom";

export default function LegacyPathRedirect({ fromBase, toBase }) {
  const location = useLocation();

  const currentPath = String(location.pathname || "");
  const currentSearch = String(location.search || "");
  const currentHash = String(location.hash || "");

  const nextPath = currentPath.startsWith(fromBase)
    ? toBase + currentPath.slice(fromBase.length)
    : toBase;

  return <Navigate to={`${nextPath}${currentSearch}${currentHash}`} replace />;
}
